export const Draft = {
    id: 1,
    value: 'DRAFT',
    name: 'Draft',
};
export const Inactive = {
    id: 2,
    value: 'INACTIVE',
    name: 'Inactive',
};
export const Published = {
    id: 3,
    value: 'PUBLISHED',
    name: 'Published',
};
export const OnHold = {
    id: 4,
    value: 'ON_HOLD',
    name: 'On Hold',
};
export const Deleted = {
    id: 5,
    value: 'DELETED',
    name: 'Deleted',
};
export const Completed = {
    id: 6,
    value: 'COMPLETED',
    name: 'Completed',
};
const All = [Draft, Inactive, Published, OnHold, Completed, Deleted];
const Basic = [Draft, Published, OnHold, Completed, Deleted];
const BasicWithoutCompleted = [Draft, Inactive, Published, OnHold, Deleted];
const BasicDefault = [Draft, Published, OnHold].map(({ value }) => value);
const BasicTask = [Draft, Published, OnHold, Completed, Deleted];
const TreeStatuses = [Draft, Inactive, OnHold, Completed, Deleted];
const BasicTaskByValue = BasicTask.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicWithoutCompletedByValue = BasicWithoutCompleted.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const AllByValue = All.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const TreeStatusesByValue = TreeStatuses.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
const BasicWithoutCompletedProps = Object.keys(BasicWithoutCompletedByValue);
export const isDeleted = node => node.learningStatus === Deleted.value;
export const isPublished = status => status === Published.value;
export default {
    Basic,
    BasicDefault,
    BasicByValue,
    BasicProps,
    BasicWithoutCompletedProps,
    BasicWithoutCompleted,
    BasicTask,
    BasicTaskByValue,
    AllByValue,
    TreeStatusesByValue,
    Draft,
    Inactive,
    Published,
    OnHold,
    Deleted,
    isDeleted,
    isPublished,
};
